export default __webpack_public_path__ + "static/media/dummy_winn.ac7ed147.png";